import { LayerRenderer } from '../LayerRenderer';
import {
  CloseButton,
  animationClass,
  cardStyle,
  useModalDialog,
  type SurfaceProps,
} from './common';

/**
 * Modální pop-up (a fullscreen přes `fullscreen` flag). `role="dialog"`,
 * `aria-modal`, focus trap, Escape, návrat fokusu, scroll-lock a `aria-hidden`
 * na pozadí řeší `useModalDialog`. Overlay se dá vypnout v nastavení; klik do
 * overlaye zavírá jen když je `closeButton` povoleno (jinak by fullscreen bez
 * zavření byl past — to ale hlídá už publikace).
 */
export function ModalSurface({
  layer,
  onClose,
  onInteract,
  onSubmitted,
  fullscreen = false,
}: SurfaceProps & { fullscreen?: boolean }) {
  const settings = layer.doc.settings;
  const ref = useModalDialog(onClose);
  const overlay = settings.overlay ?? true;
  const closeButton = settings.closeButton ?? true;
  const position = settings.position === 'top' ? 'is-top' : 'is-center';

  return (
    <div
      className={`layer-overlay${overlay ? '' : ' is-bare'}${fullscreen ? ' is-fullscreen' : ''} ${position}`}
      role="presentation"
      onClick={closeButton ? onClose : undefined}
    >
      <div
        ref={ref}
        tabIndex={-1}
        className={`layer-card ${fullscreen ? 'layer-fullscreen' : 'layer-modal'} ${animationClass(settings)}`}
        style={cardStyle(settings, !fullscreen)}
        role="dialog"
        aria-modal="true"
        aria-label={layer.doc.settings.dismissLabel ?? 'Sdělení'}
        onClick={(event) => event.stopPropagation()}
      >
        {closeButton && <CloseButton onClose={onClose} />}
        <LayerRenderer
          layer={layer}
          onClose={onClose}
          onInteract={onInteract}
          onSubmitted={onSubmitted}
        />
      </div>
    </div>
  );
}
